import { FC } from 'react';
import { AllocationTable } from '../AllocationTable';
import { WaterfallInputControl } from './WaterfallInputControl';

export const WaterfallAllocationTable: FC = () => (
  <AllocationTable
    className="waterfall-allocation-table"
    renderInputControl={(group, onGroupChange, isLastGroup) => (
      <WaterfallInputControl
        group={group}
        onGroupChange={onGroupChange}
        isLastGroup={isLastGroup}
      />
    )}
  />
);
